import type { AsyncThunkApiConfig } from '@/store'
import type { RejectError } from './typings'

import { createAsyncThunk } from '@reduxjs/toolkit'

interface Payload {
  topic: string
  message: string
}

/**
 * Open support ticket
 *
 * @private
 */
export const openSupportTicket = createAsyncThunk<
  // Return type of the payload creator
  true,
  // First argument to the payload creator
  Payload,
  // thunk API
  AsyncThunkApiConfig<RejectError>
>('support/openSupportTicket', async (payload, thunkApi) => {
  try {
    const rpc = thunkApi.extra.domainProxy.getRpc()

    const response = await rpc('rpc/support/openSupportTicket', {
      category: 'rpc',
      type: 'rpc/support/openSupportTicket',
      ticket: payload,
    })

    if (response.type === 'rpc-failure') {
      return thunkApi.rejectWithValue({
        type: 'rpcFailure',
        message: response.errorMessage,
        error: response,
      })
    }

    return true
  } catch (error) {
    thunkApi.extra.journal.main(
      `Unknown error on {openSupportTicket}`,
      { tags: ['rpc', 'support'], info: payload },
      'error',
    )

    return thunkApi.rejectWithValue({
      type: 'unknown',
      message: `Open Support Ticket failed`,
      error,
    })
  }
})
